import type { UomLadder } from 'utils/price-units';

const positive = (n?: number | null): boolean => n != null && Number.isFinite(n) && n > 0;

// Expand a unit WORD into the variant's full UOM description for display —
// "tub" → "tub of 10 × 1.2 kg" — so the rep knows exactly what package the
// price they're typing is for. Display-only: the payload/notes keep the plain
// word. Falls back to the word itself whenever the ladder can't expand it
// (missing factors, or the word isn't one of the variant's rungs).
export function fullUomLabel(ladder: UomLadder, unitWord: string): string {
  const word = unitWord.trim();
  const lowered = word.toLowerCase();

  if (ladder.packUnit?.trim().toLowerCase() === lowered && positive(ladder.packSize) && positive(ladder.netContent) && ladder.baseUnit) {
    return `${word} of ${ladder.packSize} × ${ladder.netContent} ${ladder.baseUnit}`;
  }

  if (ladder.itemUnit?.trim().toLowerCase() === lowered && positive(ladder.netContent) && ladder.baseUnit) {
    return `${word} of ${ladder.netContent} ${ladder.baseUnit}`;
  }

  return word;
}
